import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { UdcServiceService } from "../../Services/udc-service.service";
import { UserDefinedCodes } from "../../Model/user-defined-codes";
import { NgxSmartModalService } from "ngx-smart-modal";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from "@angular/forms";
import { UdcValidators } from "./udc-validators";
import { ToastrService } from "ngx-toastr";
import { ComponentSecurityService } from "src/app/Main/Services/component-security.service";
import Swal from "sweetalert2";
import { Title } from '@angular/platform-browser';

@Component({
  selector: "udc-revisions",
  templateUrl: "./udc-revisions.component.html",
  styleUrls: ["./udc-revisions.component.css"]
})
export class UdcRevisionsComponent implements OnInit {
  public factors: UserDefinedCodes[];
  public columnDefs = [];
  public rowData = [];
  private gridApi;
  private gridColumnApi;
  private gridOptions;
  private defaultColDef;
  private rowSelection;
  private crudAction;
  public form: FormGroup;
  public canUpdateForm: boolean;
  public clicked: boolean = false;
  public yesNoData = [];

  constructor(
    private service: UdcServiceService,
    public ngxSmartModalService: NgxSmartModalService,
    private udcValidators: UdcValidators,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private securityService: ComponentSecurityService,
    private titleService: Title
  ) {
    this.defaultColDef = { sortable: true, filter: true };
    this.rowSelection = "single";
    this.createFormGroup();
    this.createGridColumnDefs();
  }

  @ViewChild("key1", { static: true }) key1Field: ElementRef;

  ngOnInit() {
    this.titleService.setTitle("User Defined Codes");

    this.service.getAll().subscribe(
      response => {
        if (response.length > 0) {
          this.rowData = response;
        } else {
          this.rowData = null;
          this.toastr.warning("No records found", "Warning");
        }
      },
      error => {
        this.toastr.error("Unable to access database", "Error");
      }
    );

    // Get form security
    this.securityService
      .canUpdate(this.constructor.name, localStorage.getItem("user"))
      .subscribe(
        response => {
          if (response.length > 0) this.canUpdateForm = true;
          else {
            this.canUpdateForm = false;
                      }
        },
        error => {
          this.canUpdateForm = false;
        }
      );

    // Get dropdown values
    this.loadDropDownValues();
  }

  createFormGroup() {
    this.form = this.fb.group(
      {
        key1: new FormControl(null, [Validators.required]),
        key2: new FormControl(null, [Validators.required]),
        parentValue: new FormControl(null, [Validators.required]),
        childValue: new FormControl(""),
        labelText: new FormControl(""),
        pdText1: new FormControl(""),
        pdText2: new FormControl(""),
        pdText3: new FormControl(""),
        pdText4: new FormControl(""),
        pdText5: new FormControl(""),
        pdFlag1: new FormControl(""),
        pdFlag2: new FormControl(""),
        pdFlag3: new FormControl(""),
        pdFlag4: new FormControl(""),
        pdFlag5: new FormControl(""),
        ssrsUrl: new FormControl(""),
        rptTitle: new FormControl(""),
        rptDesc: new FormControl(""),
        visible: new FormControl(null, [Validators.required]),
        editable: new FormControl(null, [Validators.required]),
        changeID: new FormControl(""),
        lastUpdated: new FormControl(""),
        id: new FormControl("")
      },
      {
        validator: this.udcValidators.shouldBeUnique.bind(this)
      }
    );
  }

  createGridColumnDefs() {
    this.columnDefs = [
      { headerName: "id", field: "id", hide: true },
      { headerName: "changeID", field: "changeID", hide: true },
      { headerName: "lastUpdated", field: "lastUpdated", hide: true },
      {
        headerName: "Key 1",
        field: "key1",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Key 2",
        field: "key2",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Parent Value",
        field: "parentValue",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Child Value",
        field: "childValue",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Label Text",
        field: "labelText",
        filter: "agTextColumnFilter"
      },
      { headerName: "Pgm Defined Text 1", field: "pdText1", hide: true },
      { headerName: "Pgm Defined Text 2", field: "pdText2", hide: true },
      { headerName: "Pgm Defined Text 3", field: "pdText3", hide: true },
      { headerName: "Pgm Defined Text 4", field: "pdText4", hide: true },
      { headerName: "Pgm Defined Text 5", field: "pdText5", hide: true },
      { headerName: "Pgm Defined Flag 1", field: "pdFlag1", hide: true },
      { headerName: "Pgm Defined Flag 2", field: "pdFlag2", hide: true },
      { headerName: "Pgm Defined Flag 3", field: "pdFlag3", hide: true },
      { headerName: "Pgm Defined Flag 4", field: "pdFlag4", hide: true },
      { headerName: "Pgm Defined Flag 5", field: "pdFlag5", hide: true },
      { headerName: "SSRS Url", field: "ssrsUrl", hide: true },
      { headerName: "Report Title", field: "rptTitle", hide: true },
      { headerName: "Report Description", field: "rptDesc", hide: true },
      { headerName: "Visible", field: "visible", hide: true },
      { headerName: "Editable Bool Y/N", field: "editable", hide: true }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    setTimeout(() => this.key1Field.nativeElement.focus());
  }

  onSelectionChanged(event) {
    // only open the window of row selected
    if (event.node.selected) {
      this.ngxSmartModalService.setModalData(
        this.gridApi.getSelectedRows()[0],
        "myModal",
        true
      );
      this.crudAction = "Update";
      this.loadInitialFormValues();
      this.ngxSmartModalService.getModal("myModal").open();
      setTimeout(() => this.key1Field.nativeElement.focus());
    }

    // capture the event, so deselectall can be call when window closed
    this.gridOptions = event;
  }

  export() {
    let params = {
      fileName: "TypeMaster",
      allColumns: true
    };
    this.gridApi.exportDataAsExcel(params);
  }

  loadDropDownValues() {
    // Get boolean dropdown values from UDC
    // This could change to other master tables, depending on how the dropdown is loaded
    this.service.getKeyValues("Field_Name", "BooleanCode").subscribe(
      response => {
        if (response.length > 0) {
          this.yesNoData = response;
        } else {
          this.yesNoData = null;
        }
      },
      error => {
        this.yesNoData = null;
      }
    );
  }

  loadInitialFormValues() {
    this.form.patchValue({
      key1: this.gridApi.getSelectedRows()[0]["key1"],
      key2: this.gridApi.getSelectedRows()[0]["key2"],
      parentValue: this.gridApi.getSelectedRows()[0]["parentValue"],
      childValue: this.gridApi.getSelectedRows()[0]["childValue"],
      labelText: this.gridApi.getSelectedRows()[0]["labelText"],
      pdText1: this.gridApi.getSelectedRows()[0]["pdText1"],
      pdText2: this.gridApi.getSelectedRows()[0]["pdText2"],
      pdText3: this.gridApi.getSelectedRows()[0]["pdText3"],
      pdText4: this.gridApi.getSelectedRows()[0]["pdText4"],
      pdText5: this.gridApi.getSelectedRows()[0]["pdText5"],
      pdFlag1: this.gridApi.getSelectedRows()[0]["pdFlag1"],
      pdFlag2: this.gridApi.getSelectedRows()[0]["pdFlag2"],
      pdFlag3: this.gridApi.getSelectedRows()[0]["pdFlag3"],
      pdFlag4: this.gridApi.getSelectedRows()[0]["pdFlag4"],
      pdFlag5: this.gridApi.getSelectedRows()[0]["pdFlag5"],
      ssrsUrl: this.gridApi.getSelectedRows()[0]["ssrsUrl"],
      rptTitle: this.gridApi.getSelectedRows()[0]["rptTitle"],
      rptDesc: this.gridApi.getSelectedRows()[0]["rptDesc"],
      visible: this.gridApi.getSelectedRows()[0]["visible"],
      editable: this.gridApi.getSelectedRows()[0]["editable"],
      changeID: this.gridApi.getSelectedRows()[0]["changeID"],
      lastUpdated: this.gridApi.getSelectedRows()[0]["lastUpdated"],
      id: this.gridApi.getSelectedRows()[0]["id"]
    });
    this.clicked = false;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  modalAction() {
    switch (this.crudAction) {
      case "Update":
        this.service
          .update(
            this.form.value,
            this.ngxSmartModalService.getModalData("myModal").id
          )
          .subscribe(
            response => {
              if (response["success"] == "true")
                this.toastr.success("Record updated", "Success");
              this.service.getAll().subscribe(data => {
                this.rowData = data;
                this.gridApi.setRowData(this.rowData);
              });
            },
            error => {
              this.toastr.error("Record not updated", "Error");
            }
          );
        this.ngxSmartModalService.get("myModal").close();

        break;
      case "Create":
        this.service.create(this.form.value).subscribe(
          response => {
            if (response["success"] == "true")
              this.toastr.success("New record added", "Success");
            this.service.getAll().subscribe(data => {
              this.rowData = data;
              this.gridApi.setRowData(this.rowData);
            });
          },
          error => {
            this.toastr.error("Record not added", "Error");
          }
        );
        this.ngxSmartModalService.get("myModal").close();

        break;
      case "Delete":
        this.service
          .delete(this.ngxSmartModalService.getModalData("myModal").id)
          .subscribe(
            response => {
              this.toastr.success("Record deleted", "Success");
              this.service.getAll().subscribe(data => {
                this.rowData = data;
                this.gridApi.setRowData(this.rowData);
              });
            },
            error => {
              this.toastr.error("Record not deleted", "Error");
            }
          );
        this.ngxSmartModalService.get("myModal").close();

        break;
    }
  }

  close() {
    if (typeof this.gridOptions != "undefined")
      this.gridOptions.api.deselectAll();
  }

  create() {
    this.crudAction = "Create";
    this.ngxSmartModalService.resetModalData("myModal");
    this.form.reset();
    this.clicked=false;
    this.ngxSmartModalService.getModal("myModal").open();
    setTimeout(() => this.key1Field.nativeElement.focus());
  }

  // delete() {
    // this.crudAction = "Delete";
    // if (window.confirm("Are sure you want to delete this item ?")) {
      // this.modalAction();
    // } else {
      // this.ngxSmartModalService.get("myModal").close();
    // }
  // }

  delete() {
    this.crudAction = "Delete";
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then(result => {
      if (result.value) {
        this.modalAction();
      }
    });
  }
}
